module.exports = __webpack_public_path__ + "static/blink_pharma_phone-7bd074e0fa06ca326a058608935a870d.png";